import { atom } from "jotai";
import { Edge, NodeProps } from "@xyflow/react";
import { TEMP } from "@zapier/canvas-constants";
import { nodeAtomFamily } from "./nodeAtomFamily";
import { uuid, snapToAdjacentNode } from "../utils";
import { edgesAtom } from "../edges";
import { MARKER } from "../constants";
import { fetchRecommendationAtom } from "../suggestNode";
import { nodesAtom } from "./nodesAtom";

export const addSuggestedTargetNodeAsyncCommand = atom(
  null,
  async (get, set, sourceNodeId: NodeProps["id"]) => {
    const sourceNode = get(nodeAtomFamily(sourceNodeId));
    if (!sourceNode) {
      return;
    }

    const nodes = get(nodesAtom);
    // create a unique id for the suggested node
    const targetId = uuid();
    // Not used - simply to make TS happy
    const tempPosition = {
      x: 0,
      y: 0,
    };

    try {
      // Create node with recommended data
      const newNode = {
        id: targetId,
        type: "suggested",
        selected: false,
        data: {},
        position: tempPosition,
        deletable: true,
        connectable: true,
      };
      // node will have position after running snapToAdjacentNode
      const targetNode = snapToAdjacentNode({
        newNode,
        nodes,
        isPathNode: false,
        sourceNode,
      });

      // we need a connection from the source node to the new target node
      const sourceToTargetEdge: Edge = {
        id: `${sourceNode.id}=>${targetId}`,
        source: sourceNode.id,
        target: targetId,
        sourceHandle: "right",
        targetHandle: "left",
        className: TEMP,
        deletable: true,
        markerEnd: MARKER,
      };

      // Get current nodes and add the placeholder node
      const prevNodes = get(nodesAtom);
      set(nodesAtom, [...prevNodes, targetNode]);
      set(edgesAtom, (prev) => [...prev, sourceToTargetEdge]);
      set(fetchRecommendationAtom, {
        sourceNodeId: sourceNodeId,
        nodeId: targetId,
      });
    } catch (error) {
      console.error("Failed to add suggested node:", error);
    }
  },
);

addSuggestedTargetNodeAsyncCommand.debugLabel =
  "addSuggestedTargetNodeAsyncCommand";
